var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8919_11446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1504 3.0625H4.65039C3.82539 3.0625 3.15039 3.7375 3.15039 4.5625V15.0625C3.15039 15.8875 3.82539 16.5625 4.65039 16.5625H15.1504C15.9754 16.5625 16.6504 15.8875 16.6504 15.0625V4.5625C16.6504 3.7375 15.9754 3.0625 15.1504 3.0625ZM9.90789 14.3125C9.38289 14.3125 8.96289 13.8925 8.96289 13.3675C8.96289 12.835 9.38289 12.43 9.90789 12.43C10.4404 12.43 10.8454 12.835 10.8454 13.3675C10.8379 13.885 10.4404 14.3125 9.90789 14.3125ZM12.1654 8.7625C11.5954 9.595 11.0554 9.8575 10.7629 10.39C10.6429 10.6075 10.5979 10.75 10.5979 11.4475H9.23289C9.23289 11.08 9.17289 10.48 9.46539 9.9625C9.83289 9.31 10.5304 8.92 10.9354 8.3425C11.3629 7.735 11.1229 6.595 9.90789 6.595C9.11289 6.595 8.72289 7.195 8.55789 7.705L7.32039 7.18C7.65789 6.175 8.56539 5.3125 9.89289 5.3125C11.0029 5.3125 11.7604 5.815 12.1504 6.4525C12.4804 6.9925 12.6754 8.005 12.1654 8.7625Z",
    fill: "#23BA50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8919_11446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.899994 0.8125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.2f853d236aac5356b282b6bd3bd0428d.svg";
export { ForwardRef as ReactComponent };